module.exports = __webpack_public_path__ + "static/media/shape2.0cdf2ca7.webp";